<template>
  <div
    ref="errorSectionRef"
    class="max-w-4.5xl mx-auto p-6 pb-10 md:pt-[2.4375rem] md:pb-17"
    :class="{
      'bg-white shadow-bordered rounded-2xl': !noWrapper,
      '': noWrapper
    }"
  >
    <div class="w-full flex flex-col gap-7 md:gap-10">
      <div
        class="flex flex-col gap-y-10"
        :class="{
          'md:gap-y-16': !noWrapper,
          '': noWrapper
        }"
      >
        <div class="flex flex-col gap-6">
          <p
            ref="title"
            class="text-6xl md:text-6.5xl md:leading-[6rem] font-extrabold text-center"
          >
            {{ props.title }}
          </p>

          <div
            v-if="$slots.titleDesc"
            ref="titleDescRef"
            class="text-center"
          >
            <slot name="titleDesc" />
          </div>
        </div>

        <NuxtImg
          width="495"
          height="200"
          class="mx-auto max-w-full"
          :src="errorImage"
          alt="404"
        />
      </div>

      <div
        v-if="$slots.default"
        class="mx-auto w-5/4 lg:w-3/4 [&>p]:text-center"
      >
        <slot />
      </div>

      <div class="flex flex-wrap items-center justify-center gap-4 relative z-10">
        <slot name="buttons">
          <v2-atoms-button
            size="large"
            theme="primary"
            :has-icon="false"
            to="/"
          >
            Back to homepage
          </v2-atoms-button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'V2OrganismErrorSection'
})

const props = defineProps({
  title: {
    type: String,
    default: 'Oh no :('
  },

  errorImage: {
    type: String,
    default: 'https://asset.compareclub.com.au/edge/static/brand/404-illustration.svg'
  },

  noWrapper: {
    type: Boolean,
    default: false
  }
})

const $slots = useSlots()
</script>
